import api from "./axios";

/**
 * Fetches a signed URL for a file path using the authenticated API
 * @param {string} filePath - The file path (will be normalized by replacing backslashes)
 * @param {string} [downloadFileStem] - Optional filename without extension for Content-Disposition (download name)
 * @returns {Promise<string>} - The signed URL
 */
export const getSignedUrl = async (filePath, downloadFileStem) => {
  if (!filePath) {
    throw new Error("File path is required");
  }

  try {
    // Normalize the file path (replace backslashes with forward slashes)
    const normalizedPath = filePath.replace(/\\/g, "/");

    const body = { filePath: normalizedPath };
    if (downloadFileStem != null && String(downloadFileStem).trim() !== "") {
      body.downloadFileStem = String(downloadFileStem).trim();
    }

    const response = await api.post("/documents/signed-url", body);

    // Return the signed URL from the response
    // Assuming the API returns { signedUrl: "..." } or just the URL string
    return response.data.signedUrl || response.data.url || response.data;
  } catch (error) {
    console.error("Error fetching signed URL:", error);
    throw error;
  }
};
